import { sessionRevision, signalSessionExpired } from '../../auth/sessionEvents';
import { PROFILE_CONFIG } from '../../config';
export const base = PROFILE_CONFIG.apiUrl;
export const playerHref = name => `/players/${encodeURIComponent(name)}`;
export const clanHref = clan => `/rating?tab=clans&clan=${encodeURIComponent(clan.clanId ?? clan.id)}`;
export const imageHref = id => `${base}/community/images/${id}`;
export async function communityApi(path, { method = 'GET', body, admin = false, ...options } = {}) {
  const revision = sessionRevision();
  const headers = { Accept: 'application/json', ...options.headers };
  if (method !== 'GET') headers['X-IW-Action'] = 'community';
  if (body && !(body instanceof FormData)) { headers['Content-Type'] = 'application/json'; body = JSON.stringify(body); }
  if (admin) headers.Authorization = `Bearer ${localStorage.getItem('wiki_admin_token') || ''}`;
  const res = await fetch(`${base}${path}`, { ...options, method, body, credentials: 'include', headers });
  if (!admin && res.status === 401) signalSessionExpired(revision);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw Object.assign(new Error(data.message || ({ 401: 'Войди через Hytale, чтобы продолжить.', 403: 'Недостаточно прав.', 404: 'Запись не найдена.', 413: 'Максимальный размер — 8 МБ.' }[res.status]) || 'Не удалось выполнить запрос. Попробуй ещё раз.'), { status: res.status });
  }
  return res.status === 204 || res.headers.get('content-length') === '0' ? null : res.json().catch(() => null);
}
